export default __webpack_public_path__ + "static/media/search.5bc8e209.svg";